export default __webpack_public_path__ + "static/media/basic-info-gdpr.6c1aa9f2.svg";